

export default function HomeNavigation({ children, ...props }) {
    return (
        <>
            {children}
        </>
    )
}